module.exports = __webpack_public_path__ + "img/1.2999cec3.jpg";